import { BrandButton, Flex } from 'UI';
import { getTransition } from 'styles/useTransition';
import React, { FC, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { appStore } from '@store';

interface Props {
	show?: boolean;
	dividerColor?: string;
	withoutDivider?: boolean;
	backgroundColor?: string;
	backgroundColorDisabled?: string;
	textColor?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	text?: string;
	fontSize?: number;
	FONT_WEIGHT?: number;
	textTransform?: 'capitalize' | 'uppercase' | 'none' | 'lowercase';
	borderRadius?: number;
	minHeight?: number;
	maxWidth?: number;
	disabled?: boolean;
	top?: string;
}

const Container = styled.div<Props>`
	position: fixed;
	top: ${({ top }) => top};
	left: 0;
	background-color: ${({ theme }) => theme.colors.bg1};
	height: ${({ theme }) => theme.continiueButtonHeight ?? '80px'};
	width: 100vw;
	display: none;
	opacity: 0;
	${({ theme }) => getTransition(theme.durations.ms300, 'opacity')};
	${({ show }) =>
		show &&
		css`
			opacity: 1;
			display: block;
		`}
`;

const Divider = styled.div<Props>`
	width: 100vw;
	height: 1px;
	${({ withoutDivider }) =>
		withoutDivider &&
		css`
			display: none;
		`}
	margin-bottom: 10px;
	background: ${({ theme }) => theme.colors.border2};
`;

const ButtonContainer = styled.div`
	width: 100%;
	max-width: ${({ theme }) => theme.containerWidth};
	padding: 0 20px;
`;

export const BottomButton: FC<Props> = props => {
	const { show, withoutDivider } = props;
	const { currentStep } = appStore.surveyStore;
	const [top, setTop] = useState('calc(100% - 80px)');
	const [currentStepName, setSurrentStepName] = useState('null');

	useEffect(() => {
		let interval: any;

		if (
			currentStep?.name === 'height' ||
			currentStep?.name === 'weight' ||
			currentStep?.name === 'target_weight2' ||
			currentStep?.name === 'mail2' ||
			currentStep?.name === 'target_weight' ||
			currentStep?.name === 'mail'
		) {
			interval = setInterval(() => {
				if (visualViewport?.height) {
					setTop(`${visualViewport.height - 80}px`);
				}
			}, 1);
		} else {
			setTop('calc(100% - 80px)');
		}

		return () => clearInterval(interval);
	}, [currentStep]);

	return (
		<Container show={show} top={top}>
			<Divider withoutDivider={withoutDivider} />
			<Flex justify='center'>
				<ButtonContainer>
					<BrandButton {...props} />
				</ButtonContainer>
			</Flex>
		</Container>
	);
};
